"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.checkCon = void 0;

var _constant = _interopRequireDefault(require("./constant"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var colon = _constant["default"].colon,
    pixel = _constant["default"].pixel,
    maxWidth = _constant["default"].maxWidth,
    minWidth = _constant["default"].minWidth,
    windowWidth = _constant["default"].windowWidth;

var isTrue = function isTrue(ww, v, p) {
  return p === minWidth ? ww > v : ww < v;
};

var checkCon = function checkCon(_ref) {
  var p = _ref.p,
      v = _ref.v;

  switch (p) {
    case maxWidth:
      return isTrue(windowWidth, v, p);

    case minWidth:
      return isTrue(windowWidth, v, p);

    default:
      return false;
  }
};

exports.checkCon = checkCon;

var change = function change(q) {
  var qArr = q.split(colon);
  var p = qArr[0];
  var v = qArr[1].replace(pixel, '').trim();
  return {
    p: p,
    v: v
  };
};

var getQueryHandler = function getQueryHandler(q) {
  return change(q);
};

var _default = getQueryHandler;
exports["default"] = _default;